/* ---------------------------------------------------------------------------
   Cart gift reconciler

   Die Wandhalterung wird über native Shopify "Kaufe X, erhalte Y"-Rabatte auf
   0 € gesetzt. Ein solcher Rabatt legt das Geschenk aber NICHT selbst in den
   Warenkorb — er rabattiert nur, was schon drin liegt. Dieses Script hält den
   Warenkorb deshalb im Soll-Zustand:

     0 Schutzhüllen  -> kein Geschenk
     1 Schutzhülle   -> Wall Mount Single
     2+ Schutzhüllen -> Wall Mount Double

   Alles Sichtbare rendert snippets/cart-gift.liquid serverseitig — hier passiert
   nur die Cart-Mutation plus ein Refresh der Cart-Sections.
   --------------------------------------------------------------------------- */

(function () {
	if (window.__cartGiftInit) {
		return;
	}

	window.__cartGiftInit = true;

	var GIFT_PROPERTY = '_gift';
	var DEBOUNCE_MS = 60;

	var selectors = {
		root: '[data-cart-gift]',
		config: '[data-cart-gift-config]',
		section: '[data-section-type="cart-template"]',
		headerCount: '.js-header-cart-item-count',
		headerCountWrapper: '.js-header-cart-item-count-wrapper',
		quantityError: '.js-cart-item-error-message',
		quantityInput: '[data-quantity-input]'
	};

	var busy = false;
	var rerun = false;
	var lastCart = null;
	var debounceTimer = null;

	function getConfig() {
		var el = document.querySelector(selectors.config);

		if (!el) {
			return null;
		}

		try {
			return JSON.parse(el.textContent);
		} catch (error) {
			return null;
		}
	}

	function getSectionIds() {
		return Array.prototype.slice
			.call(document.querySelectorAll(selectors.section))
			.map(function (section) {
				return section.dataset.sectionId;
			})
			.filter(Boolean)
			.join(',');
	}

	function isGiftLine(item) {
		return Boolean(item.properties && item.properties[GIFT_PROPERTY] === 'true');
	}

	/**
	 * Erkennt von Shopify aufgetrennte Zeilen.
	 *
	 * Shopify trennt genau die Einheiten ab, die den "Kaufe X"-Teil des Rabatts
	 * erfüllen. Bei 3 gleichen Schutzhüllen entstehen deshalb zwei Zeilen (2 + 1),
	 * bei 5 ebenfalls zwei (2 + 3). Das ist kein Fehler und nicht vermeidbar — die
	 * Preise stimmen, es sind nur zwei Zeilen statt einer.
	 *
	 * Relevant ist der Zustand nur, weil die Mengenprüfung des Themes darin
	 * fälschlich anschlägt (siehe clearQuantityErrors).
	 */
	function hasSplitLines(cart) {
		var seen = {};
		var split = false;

		cart.items.forEach(function (item) {
			if (isGiftLine(item)) {
				return;
			}

			var signature = item.variant_id + '|' + JSON.stringify(item.properties || {});

			if (seen[signature]) {
				split = true;
			}

			seen[signature] = true;
		});

		return split;
	}

	/**
	 * Nach einem Split meldet das Theme fälschlich "You can only add N of X to your
	 * cart": Es sucht die Zeile über ihren Key und findet dort nur noch einen Teil
	 * der Menge — der Rest steckt in der abgetrennten Zeile. Die Ware liegt
	 * vollständig im Warenkorb, die Meldung ist also falsch.
	 *
	 * Bewusste Abwägung: Träfe gleichzeitig eine echte Bestandsgrenze zu, würde
	 * deren Meldung mit unterdrückt. Die korrigierte Menge zeigt das Theme danach
	 * ohnehin an; ein dauerhaft falscher Fehler wäre das größere Übel.
	 */
	function clearQuantityErrors() {
		Array.prototype.slice.call(document.querySelectorAll(selectors.quantityError)).forEach(function (el) {
			el.innerHTML = '';
		});
	}

	function post(url, body) {
		return fetch(url, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			body: JSON.stringify(body)
		}).then(function (response) {
			if (!response.ok) {
				return response.json().then(
					function (data) {
						return Promise.reject(data);
					},
					function () {
						return Promise.reject(response);
					}
				);
			}

			return response.json();
		});
	}

	/**
	 * cart:updated trägt je nach Auslöser nur eine Teilantwort: /cart/add.js
	 * liefert ausschließlich die hinzugefügten Zeilen, ohne item_count. Nur ein
	 * Objekt mit item_count ist ein vollständiger Warenkorb.
	 */
	function resolveCart(data) {
		if (data && typeof data.item_count === 'number' && Array.isArray(data.items)) {
			return Promise.resolve(data);
		}

		return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
			return response.json();
		});
	}

	/**
	 * Leitet den Soll-Zustand aus einem Cart-Objekt ab.
	 * Wandhalterungen ohne _gift-Property sind bewusst gekaufte Exemplare —
	 * die zählen weder als Schutzhülle noch als Geschenk und werden nie angefasst.
	 */
	function readState(cart, config) {
		var coverUnits = 0;
		var giftLines = [];
		var giftProductIds = config.giftProductIds || [];

		cart.items.forEach(function (item) {
			if (isGiftLine(item)) {
				giftLines.push(item);
				return;
			}

			if (giftProductIds.indexOf(item.product_id) !== -1) {
				return;
			}

			coverUnits += item.quantity;
		});

		var desired = null;
		var desiredSoldOut = false;

		if (coverUnits >= 2) {
			if (config.doubleAvailable) {
				desired = config.doubleVariantId;
			} else {
				desiredSoldOut = true;
			}
		} else if (coverUnits === 1) {
			if (config.singleAvailable) {
				desired = config.singleVariantId;
			} else {
				desiredSoldOut = true;
			}
		}

		return {
			giftLines: giftLines,
			desired: desired,
			desiredSoldOut: desiredSoldOut
		};
	}

	/**
	 * Ermittelt den nächsten nötigen Schritt. Gibt null zurück, wenn Ist == Soll.
	 *
	 * Bewusst nur EIN Schritt pro Aufruf: Shopify ändert den Line-Item-Key einer
	 * Zeile, sobald sich ihre Rabattzuordnung ändert. Ein vorab eingesammelter
	 * Key ist nach der ersten Mutation also wertlos ("no valid id or line
	 * parameter") — es muss nach jedem Request neu abgeleitet werden.
	 */
	function nextStep(state) {
		var keeper = null;
		var drop = [];

		state.giftLines.forEach(function (line) {
			if (!keeper && state.desired !== null && line.variant_id === state.desired) {
				keeper = line;
				return;
			}

			drop.push(line);
		});

		// Ist das Wunsch-Geschenk nur ausverkauft, bleibt ein bereits vorhandenes
		// Geschenk lieber liegen, statt es dem Kunden wegzunehmen.
		if (state.desired === null && state.desiredSoldOut) {
			drop = [];
		}

		// Erst aufräumen, dann hinzufügen: Liegt beim Upgrade kurzzeitig die alte
		// UND die neue Variante im Warenkorb, verliert eine davon ihren Rabatt und
		// würde dem Kunden berechnet, falls der Folge-Request scheitert.
		if (drop.length) {
			return { type: 'remove', line: drop[0] };
		}

		if (keeper && keeper.quantity !== 1) {
			return { type: 'quantity', line: keeper };
		}

		if (state.desired !== null && !keeper) {
			return { type: 'add', variantId: state.desired };
		}

		return null;
	}

	function setLoading(isLoading) {
		Array.prototype.slice.call(document.querySelectorAll(selectors.root)).forEach(function (el) {
			el.classList.toggle('is-loading', isLoading);
		});
	}

	/**
	 * Der Header-Badge wird von section-header.build.min.js direkt aus
	 * cart.item_count gesetzt — inklusive der ausgeblendeten Geschenkzeile.
	 * Hier wird auf die tatsächlich sichtbare Menge korrigiert.
	 */
	function updateHeaderCount(cart) {
		if (!cart || !Array.isArray(cart.items)) {
			return;
		}

		var count = cart.items.reduce(function (total, item) {
			return isGiftLine(item) ? total : total + item.quantity;
		}, 0);

		Array.prototype.slice.call(document.querySelectorAll(selectors.headerCount)).forEach(function (el) {
			el.innerHTML = count > 99 ? '99+' : String(count);
		});

		Array.prototype.slice.call(document.querySelectorAll(selectors.headerCountWrapper)).forEach(function (el) {
			el.setAttribute('data-cart-count', String(count));
		});
	}

	function applyCart(cart) {
		if (!cart) {
			return;
		}

		lastCart = cart;
		window.themeCore.cartObject = cart;
		updateHeaderCount(cart);

		// refreshSections() nimmt mitgeliefertes Section-HTML direkt entgegen und
		// spart sich den zweiten Fetch. Ein leeres Objekt erzwingt den Fetch.
		window.themeCore.EventBus.emit('cart:refresh', cart.sections || {});
	}

	/**
	 * Führt einen Schritt aus und liefert den daraus resultierenden Warenkorb —
	 * oder null, wenn der Soll-Zustand damit erreicht ist.
	 *
	 * 'add' ist immer der letzte Schritt: nextStep räumt erst auf und legt erst
	 * danach an. Deshalb braucht es hier kein zusätzliches /cart.js, um die
	 * Schleife fortzusetzen — das spart einen Roundtrip und damit Zeit, in der
	 * der Drawer veraltete Mengen anzeigen würde.
	 */
	function runStep(step) {
		if (step.type === 'add') {
			var properties = {};
			properties[GIFT_PROPERTY] = 'true';

			return post('/cart/add.js', {
				items: [{ id: step.variantId, quantity: 1, properties: properties }]
			}).then(function () {
				return null;
			});
		}

		return post('/cart/change.js', {
			id: step.line.key,
			quantity: step.type === 'quantity' ? 1 : 0
		});
	}

	/**
	 * Gleicht den Warenkorb ab. Erfüllt mit true, wenn dabei etwas geändert und
	 * damit auch neu gerendert wurde — der Aufrufer muss dann nicht selbst
	 * refreshen.
	 */
	function reconcile(cart) {
		if (!cart || !Array.isArray(cart.items)) {
			return Promise.resolve(false);
		}

		lastCart = cart;

		if (busy) {
			rerun = true;
			return Promise.resolve(false);
		}

		var config = getConfig();

		if (!config) {
			return Promise.resolve(false);
		}

		var firstStep = nextStep(readState(cart, config));

		if (!firstStep) {
			return Promise.resolve(false);
		}

		busy = true;
		setLoading(true);

		// Höchstens ein Add plus ein paar Removes; die Grenze fängt nur den Fall ab,
		// dass der Soll-Zustand wider Erwarten nie erreicht wird.
		var remaining = 6;

		function runFrom(step) {
			if (!step) {
				return Promise.resolve();
			}

			remaining -= 1;

			if (remaining < 0) {
				console.warn('[cart-gift] Abgleich nach zu vielen Schritten abgebrochen.');
				return Promise.resolve();
			}

			return runStep(step).then(function (updated) {
				if (!updated) {
					return undefined;
				}

				return runFrom(nextStep(readState(updated, config)));
			});
		}

		return runFrom(firstStep)
			.then(function () {
				// Liefert den vollen Warenkorb UND das gerenderte Section-HTML in einem Request.
				return post('/cart/update.js', { updates: {}, sections: getSectionIds() });
			})
			.then(applyCart)
			.catch(function (error) {
				console.warn('[cart-gift] Geschenk konnte nicht aktualisiert werden:', error);
			})
			.then(function () {
				busy = false;
				setLoading(false);

				if (rerun) {
					rerun = false;
					return reconcile(lastCart);
				}

				return true;
			});
	}

	function onCartUpdated(data) {
		// Der Header-Handler des Themes läuft auf demselben Event und schreibt den
		// rohen item_count. Sofort nachziehen, damit der Badge nicht kurz springt.
		var suppressedError = false;

		if (data && typeof data.item_count === 'number' && Array.isArray(data.items)) {
			updateHeaderCount(data);

			// Die Mengen-Fehlermeldung des Themes steht zu diesem Zeitpunkt schon im
			// DOM. Bei aufgetrennten Zeilen ist sie falsch — direkt hier weg, sonst
			// blitzt sie bis zum nächsten Rendern auf.
			if (hasSplitLines(data)) {
				clearQuantityErrors();
				suppressedError = true;
			}
		}

		clearTimeout(debounceTimer);

		debounceTimer = setTimeout(function () {
			resolveCart(data)
				.then(function (cart) {
					if (cart !== data) {
						updateHeaderCount(cart);
					}

					return reconcile(cart);
				})
				.then(function (didReconcile) {
					// Hat das Theme einen Mengenfehler gemeldet, überspringt es sein
					// eigenes Neurendern (hasErrors). Ohne Abgleich stünde im Drawer
					// dann die zurückgesetzte alte Menge statt der echten.
					if (suppressedError && !didReconcile) {
						window.themeCore.EventBus.emit('cart:refresh', {});
					}
				})
				.catch(function (error) {
					console.warn('[cart-gift] Warenkorb konnte nicht gelesen werden:', error);
				});
		}, DEBOUNCE_MS);
	}

	/**
	 * Unterbindet den doppelten Versand des Themes bei Mengenänderungen.
	 *
	 * onChangeQuantityClick ruft erst dispatch() (= ein /cart/change.js) und feuert
	 * danach zusätzlich ein synthetisches 'change'-Event auf das Input, das über
	 * onQuantityInput ein zweites, identisches /cart/change.js auslöst.
	 *
	 * Ohne Rabatt ist das folgenlos, weil "setze Zeile auf 2" idempotent ist. Mit
	 * dem Geschenk-Rabatt nicht: Der erste Request trennt die Zeile auf und lässt
	 * den ursprünglichen Key mit Menge 1 zurück — der zweite setzt genau den von 1
	 * auf 2 und legt damit eine Einheit zu viel in den Warenkorb.
	 *
	 * Ein Listener in der Capture-Phase auf document läuft vor den Listenern am
	 * Input selbst und kann das Event dort abfangen. Getroffen werden nur
	 * synthetische Events (isTrusted === false) an Mengenfeldern im Warenkorb —
	 * tippt jemand eine Menge von Hand ein, ist das Event echt und läuft normal
	 * durch.
	 */
	function blockSyntheticQuantityChange() {
		document.addEventListener(
			'change',
			function (event) {
				if (event.isTrusted) {
					return;
				}

				var target = event.target;

				if (!target || !target.closest || !target.closest(selectors.quantityInput)) {
					return;
				}

				if (!target.closest(selectors.section)) {
					return;
				}

				event.stopPropagation();
			},
			true
		);
	}

	function init() {
		if (!window.themeCore || !window.themeCore.EventBus) {
			return;
		}

		blockSyntheticQuantityChange();

		window.themeCore.EventBus.listen('cart:updated', onCartUpdated);

		// Beim Direkteinstieg kommt der Warenkorb aus snippets/js-objects.liquid.
		var initialCart = window.themeCore.cartObject;

		if (initialCart && Array.isArray(initialCart.items)) {
			updateHeaderCount(initialCart);
			reconcile(initialCart);
		}
	}

	if (window.themeCore && window.themeCore.loaded) {
		init();
	} else {
		document.addEventListener('theme:all:loaded', init, { once: true });
	}
})();
